import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { AuthenticationService } from '../../../core/services/auth.service';
import { AuthfakeauthenticationService } from '../../../core/services/authfake.service';

import { ActivatedRoute, Router } from '@angular/router';
import { first } from 'rxjs/operators';

import { environment } from '../../../../environments/environment';
@Component({
    selector: 'app-login-acccount',
    templateUrl: './login-acccount.component.html',
    styleUrls: ['./login-acccount.component.scss']
})
export class LoginAcccountComponent implements OnInit {


    loginForm: FormGroup;
    submitted = false;
    error = '';
    returnUrl: string;

    // set the currenr year
    year: number = new Date().getFullYear();
    isChecked: boolean = false;
    @ViewChild('phoneInput') phoneInput: ElementRef | undefined;
    @ViewChild('passwordInput') passwordInput: ElementRef | undefined;
    // tslint:disable-next-line: max-line-length
    constructor(
        private formBuilder: FormBuilder,
        private route: ActivatedRoute,
        private router: Router,
        public authenticationService: AuthenticationService,
        public authFackservice: AuthfakeauthenticationService

    ) {
    }

    ngOnInit() {
        document.body.removeAttribute('data-layout');
        document.body.classList.add('auth-body-bg');

        this.loginForm = this.formBuilder.group({
            phone: ['', [Validators.required]],
            password: ['', [Validators.required]],
        });

        // reset login status
        // this.authenticationService.logout();
        // get return url from route parameters or default to '/'
        // tslint:disable-next-line: no-string-literal
        this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
    }

    // convenience getter for easy access to form fields
    get f() { return this.loginForm.controls; }
    /**
     * Form submit
     */
    onSubmit() {
        this.submitted = true;

        // stop here if form is invalid
        if (this.loginForm.invalid) {
            return;
        } else {
            if (environment.defaultauth === 'firebase') {
                this.authenticationService.login(this.f.phone.value, this.f.password.value).then((res: any) => {
                    this.router.navigate(['/']);
                })
                    .catch(error => {
                        this.error = error ? error : '';
                    });
            } else {
                const data = this.loginForm.value
                this.authFackservice.loginMobileByPhone(this.f.phone.value, this.f.password.value)
                    .pipe(first())
                    .subscribe(
                        data => {
                            console.log(data['data'].role);
                            if (data && data['data'].role === 'admin') {
                                this.router.navigate(['/']);
                            } else if (data && data['data'].role === 'partner_operation') {
                                this.router.navigate(['/MB-dashboard']);
                            } else {
                                if (data['data'].is_workspace === 1) {
                                    this.router.navigate(['/account/workspace-mobile']);
                                } else {
                                    this.router.navigate(['/account/landing-page']);
                                }
                            }
                        },
                        error => {
                            this.error = error ? error : '';
                        });
            }
        }
    }
    showPassword: boolean = false;

    toggleShowPassword() {
        this.showPassword = !this.showPassword;
        if (this.showPassword) {
            setTimeout(() => {
                this.showPassword = false;
            }, 2000);
        }
    }
}
